import React from 'react';
import { Link } from 'react-router-dom';
import { 
  RiGlobalLine, 
  RiPhoneLine,
  RiMapPinLine,
  RiCalendarLine,
  RiShieldCheckLine,
  RiTimeLine,
  RiInformationLine,
  RiExternalLinkLine,
  RiEyeLine,
  RiMailLine,
  RiMessageLine,
  RiCustomerService2Line,
  RiFileList3Line,
  RiGovernmentLine,
  RiQuestionAnswerLine
} from 'react-icons/ri';
import SEO from '../components/SEO';
import './Contact.css';

const Contact = () => {
  return (
    <>
      <SEO
        title="Contact BTRC - Bangladesh Telecommunication Regulatory Commission | NEIR Support"
        description="Contact Bangladesh Telecommunication Regulatory Commission (BTRC) for NEIR support, inquiries, and assistance. Official contact information including address, helpline, email, and office hours. Get help with IMEI verification, mobile device registration, and NEIR system queries. Government telecommunications commission contact details."
        keywords="Contact BTRC, Contact NEIR BTRC, Contact NEIR Bangladesh, Contact NEIR.gov.bd, Contact NEIR.btrc.gov.bd, Contact neir.btrc.gov.bd, Bangladesh Telecommunication Regulatory Commission contact, NEIR support, BTRC helpline, government telecommunications contact, official BTRC contact, NEIR customer service, Bangladesh telecom regulatory contact, government mobile database support, official NEIR contact, BTRC office address, government telecommunications support, NEIR help desk, official government contact, Bangladesh mobile device support, government mobile services contact, BTRC customer service, official telecommunications commission contact, NEIR inquiries, government mobile database contact, Bangladesh telecom regulatory support, official device registration support, government mobile verification contact, BTRC official contact information, NEIR official support, government telecommunications helpline, Bangladesh mobile network support, official mobile services contact, government mobile database helpline, BTRC contact details, neir.btrc.gov.bd contact, www.neir.btrc.gov.bd contact, neir portal contact, btrc neir portal contact, neir btrc website contact, neir btrc official contact, neir btrc support, neir btrc helpline, neir btrc customer service, neir btrc help desk, neir btrc inquiries, neir btrc bangladesh contact, neir btrc gov contact, neir btrc government contact, .gov.bd contact, gov.bd domain contact, government domain Bangladesh contact, official government domain contact, btrc.gov.bd contact, neir.btrc.gov.bd contact, www.btrc.gov.bd contact, www.neir.btrc.gov.bd contact"
        ogTitle="Contact BTRC - Bangladesh Telecommunication Regulatory Commission | NEIR Support"
        ogDescription="Contact Bangladesh Telecommunication Regulatory Commission (BTRC) for NEIR support, inquiries, and assistance."
        ogImage="/images/btrc-logo.png"
        canonicalUrl="https://neir.btrc.gov.bd/contact"
      />
      <div className="contact-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <div className="page-header-content">
            <div className="header-icon-wrapper">
              <RiMessageLine className="header-icon" />
            </div>
            <h1 className="page-title">
              <span className="gradient-text">Contact Information</span>
            </h1>
            <p className="page-subtitle">
              Get in touch with Bangladesh Telecommunication Regulatory Commission (BTRC) for NEIR support and inquiries
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section section">
        <div className="container">
          <div className="section-header text-center">
            <div className="section-icon-wrapper">
              <RiCustomerService2Line className="section-icon" />
            </div>
            <h2 className="section-title">
              <span className="gradient-text">Contact Information</span>
            </h2>
            <p className="section-subtitle">
              Reach out to BTRC for NEIR support, inquiries, and technical assistance
            </p>
          </div>
          
          <div className="contact-cards">
            <div className="contact-card">
              <div className="contact-icon">
                <RiGovernmentLine />
              </div>
              <h5>Organization</h5>
              <p>Bangladesh Telecommunication Regulatory Commission (BTRC)</p>
              <p className="contact-detail">Regulatory Authority</p>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">
                <RiMapPinLine />
              </div>
              <h5>Address</h5>
              <p>BTRC Building, IEB Bhaban (5th Floor)</p>
              <p className="contact-detail">Ramna, Dhaka-1000, Bangladesh</p>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">
                <RiGlobalLine />
              </div>
              <h5>Official Website</h5>
              <p>
                <a 
                  href="https://neir.btrc.gov.bd" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  neir.btrc.gov.bd
                </a>
              </p>
              <p className="contact-detail">
                <a 
                  href="https://www.btrc.gov.bd" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  btrc.gov.bd
                </a>
              </p>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">
                <RiPhoneLine />
              </div>
              <h5>Helpline</h5>
              <p>BTRC Customer Service</p>
              <p className="contact-detail">Available during office hours</p>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">
                <RiMailLine />
              </div>
              <h5>Email</h5>
              <p>
                <a 
                  href="mailto:info@btrc.gov.bd" 
                  className="contact-link"
                >
                  info@btrc.gov.bd
                </a>
              </p>
              <p className="contact-detail">For general inquiries</p>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">
                <RiTimeLine />
              </div>
              <h5>Office Hours</h5>
              <p>Sunday - Thursday</p>
              <p className="contact-detail">9:00 AM - 5:00 PM (BST)</p>
            </div>
          </div>

          {/* Additional Information */}
          <div className="info-box-container">
            <div className="info-box">
              <h3 className="info-box-title">
                <RiInformationLine /> Important Information
              </h3>
              <div className="info-grid">
                <div className="info-item">
                  <h5><RiMapPinLine /> Location</h5>
                  <p>Dhaka, Bangladesh</p>
                </div>
                <div className="info-item">
                  <h5><RiCalendarLine /> NEIR Launch</h5>
                  <p>18 February 2020</p>
                </div>
                <div className="info-item">
                  <h5><RiShieldCheckLine /> System Status</h5>
                  <p>Active and Operational</p>
                </div>
                <div className="info-item">
                  <h5><RiTimeLine /> Service Availability</h5>
                  <p>24/7 Online Service</p>
                </div>
                <div className="info-item">
                  <h5><RiQuestionAnswerLine /> Support</h5>
                  <p>Available via Portal</p>
                </div>
                <div className="info-item">
                  <h5><RiFileList3Line /> Documentation</h5>
                  <p>Available on Website</p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="quick-links-section">
            <h3 className="quick-links-title">Quick Links</h3>
            <div className="quick-links">
              <a 
                href="https://neir.btrc.gov.bd" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                <RiExternalLinkLine /> Official NEIR Website
              </a>
              <a 
                href="https://btrc.portal.gov.bd/site/page/19ac6abd-d10b-4cd3-80ba-0c83ebed7c1b" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                <RiExternalLinkLine /> BTRC Portal - NEIR Page
              </a>
              <Link to="/about" className="btn btn-outline">
                <RiInformationLine /> Learn About NEIR
              </Link>
              <Link to="/features" className="btn btn-outline">
                <RiEyeLine /> View Features
              </Link>
            </div>
          </div>
        </div>
      </section>
      </div>
    </>
  );
};

export default Contact;

